import { CmsCase } from '@/lib/supabase';

interface CaseHeroProps {
  caseData: CmsCase;
}

export default function CaseHero({ caseData }: CaseHeroProps) {
  const tags = caseData.tags || [];

  return (
    <div className="relative">
      <div className="relative h-[500px] overflow-hidden">
        <img
          src={caseData.hero_bg || caseData.cover_image || 'https://public.readdy.ai/ai/img_res/dc890354ca504ae55233f7ccb151dc5d.jpg'}
          alt={caseData.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
            <div className="text-white">
              {tags.length > 0 && (
                <div className="flex flex-wrap gap-3 mb-6">
                  {tags.map((tag, index) => (
                    <span key={index} className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium">
                      {tag}
                    </span>
                  ))}
                </div>
              )}
              <h1 className="text-5xl lg:text-6xl font-bold mb-6">{caseData.title}</h1>
              <div className="flex flex-wrap gap-8 text-lg">
                {caseData.client && (
                  <div>
                    <span className="text-white/70">客户：</span>
                    <span className="font-medium">{caseData.client}</span>
                  </div>
                )}
                {caseData.industry && (
                  <div>
                    <span className="text-white/70">行业：</span>
                    <span className="font-medium">{caseData.industry}</span>
                  </div>
                )}
                {caseData.project_date && (
                  <div>
                    <span className="text-white/70">项目周期：</span>
                    <span className="font-medium">{caseData.project_date}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm flex-wrap">
            <a href="/" className="text-gray-600 hover:text-teal-600 transition-colors">首页</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <button onClick={() => window.history.back()} className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">成功案例</button>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-medium">{caseData.title}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
